var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"donut"},[_c('div',{staticClass:"donut-inner"},[_c('b',[_vm._v(_vm._s(_vm.sumOfTotal))]),_c('Br'),_c('small',[_vm._v(" Total ")])],1),_c('CChartDoughnut',{attrs:{"datasets":_vm.defaultDatasets,"labels":_vm.labels,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }